var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHistoryDepositIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 27,
    viewBox: "0 0 29 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 3.73885C18 2.9917 17.3246 2.42619 16.5891 2.55754L2.98905 4.98611C2.41674 5.08831 2 5.58605 2 6.16742V6.99997V7.99997V20C2 20.2652 2.10536 20.5195 2.29289 20.7071C2.48043 20.8946 2.73478 21 3 21H21C21.2652 21 21.5196 20.8946 21.7071 20.7071C21.8946 20.5195 22 20.2652 22 20V7.99997C22 7.73475 21.8946 7.4804 21.7071 7.29286C21.5196 7.10533 21.2652 6.99997 21 6.99997H19H18V3.73885ZM16 6.99997V4.69436L4 6.83722V6.99997H16ZM4 8.99997V19H20V8.99997H4ZM15 13H18V15H15V13Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 20C28.5 16.4101 25.5899 13.5 22 13.5C18.4101 13.5 15.5 16.4101 15.5 20C15.5 23.5899 18.4101 26.5 22 26.5C25.5899 26.5 28.5 23.5899 28.5 20Z",
    fill: "#F9FAFB",
    stroke: "#2D3344"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 20V24H21.5V20H18L22 16L26 20H22.5Z",
    fill: "#22C55E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryDepositIcon);
export default __webpack_public_path__ + "static/media/history_deposit_icon.f13fc340f459491f4ec3ddffd202ac06.svg";
export { ForwardRef as ReactComponent };